<template>
  <div>
    <v-row>
      <v-col>
        <v-card flat outlined>
          <v-card-title>取り込み履歴</v-card-title>
          <v-card-subtitle class="text-right">
            <v-btn
              small
              class="info"
              @click="reload"
            >
              再読み込み
            </v-btn>
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="importResults"
              :items-per-page="-1"
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.status`]="{ item }">
                <v-chip
                  :color="chipColor(item)"
                  label
                  small
                >
                  {{ item.status_name }}
                </v-chip>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.has_error`]="{ item }">
                <v-btn
                  :disabled="!item.has_error"
                  small
                  color="error"
                  @click="showErrorDialogClickEvent(item)"
                >
                  詳細
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>

    <v-dialog
      v-model="enableErrorDialog"
      scrollable
      width="650"
    >
      <v-card>
        <v-card-title>取り込みエラー詳細</v-card-title>
        <v-card-subtitle>
          最大50件のエラーを表示
        </v-card-subtitle>
        <v-card-text>
          <v-data-table
            :headers="importErrorHeaders"
            :items="importErrorMessages"
            :items-per-page="-1"
            dense
            disable-sort
            hide-default-footer
            fixed-header
            height="300"
          >
            <template v-slot:[`item.messages`]="{ item }">
              <div
                v-for="message in item.messages"
                :key="message"
                class="red--text"
              >
                <small>{{ message }}</small>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeErrorDialogClickEvent"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'CsvImportResults',
  components: {},
  mixins: [],
  props: {
    importType: {
      type: String,
      default: () => null,
    },
    doReload: {
      type: Number,
      default: () => null,
    }
  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      pagination: {
        current_page: 1,
        total_count: 0
      },
      tableHeaders: [
        { value: 'status', text: 'ステータス', align: 'center' },
        { value: 'created_at', text: 'アップロード日時' },
        { value: 'file_name', text: 'ファイル名' },
        { value: 'has_error', text: '', align: 'end' },
      ],
      importResults: [],
      importErrorHeaders: [
        { value: 'index', text: '行番号', align: 'start' },
        { value: 'messages', text: '内容', align: 'start' },
      ],
      enableErrorDialog: false,
      importErrorMessages: [],
    }
  },
  computed: {},
  watch: {
    enableErrorDialog () {

    },
    doReload () {
      this.reload()
    }
  },
  created() {
    this.reload()
  },
  methods: {
    ...mapActions('DriverCsvImportTask', {
      fetchTasks: 'index',
    }),
    ...mapActions('DriverCsvImportTask', {
      fetchErrors: 'show',
    }),
    chipColor (item) {
      let color = null
      switch (item.status) {
        case 'standby':
          color = ''
          break
        case 'in_process':
          color = 'secondary'
          break
        case 'fetched_error':
          color = 'error'
          break
        case 'completed':
          color = 'primary'
          break
        case 'canceled':
          color = 'orange'
          break
        case 'failure':
          color = 'error'
          break
        default:

      }
      return color
    },
    changePage () {
      this.searchTasks()
    },
    reload () {
      this.page = 1
      this.searchTasks()
    },
    showErrorDialogClickEvent (item) {
      /**
       * @typedef content { Object }
       * @property processing_results { Array }
       */
      this.fetchErrors({id: item.id}).then((content) => {
        this.importErrorMessages = content.processing_results
        this.enableErrorDialog = true
      })
    },
    closeErrorDialogClickEvent () {
      this.enableErrorDialog = false
    },
    searchTasks () {
      /**
       * @typedef content { Object }
       * @property csv_import_tasks { Array }
       * @property pagination { Object }
       */
      this.fetchTasks({type: this.importType, page: this.page}).then((content) => {
        this.importResults = content.csv_import_tasks
        this.pagination = content.pagination
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
